/* Progressive filtering and sorting for the 195-show price directory. */
(() => {
  const directory = document.querySelector('[data-price-directory]');
  if (!directory) return;
  const controls = {
    search: document.getElementById('price-search'),
    band: document.getElementById('price-band'),
    region: document.getElementById('price-region'),
    sector: document.getElementById('price-sector'),
    offer: document.getElementById('price-offer'),
    sort: document.getElementById('price-sort'),
  };
  const results = document.getElementById('price-results');
  const count = document.getElementById('price-count');
  const empty = document.getElementById('price-empty');
  const reset = document.getElementById('price-reset');
  const cards = [...results.querySelectorAll('[data-price-record]')];

  function update() {
    const query = controls.search.value.trim().toLowerCase();
    let visible = 0;
    cards.forEach(card => {
      const show = (!query || card.dataset.search.includes(query)) &&
        (!controls.band.value || card.dataset.band === controls.band.value) &&
        (!controls.region.value || card.dataset.region === controls.region.value) &&
        (!controls.sector.value || card.dataset.sector === controls.sector.value) &&
        (!controls.offer.value || card.dataset.offer === controls.offer.value);
      card.hidden = !show;
      if (show) visible += 1;
    });
    const sorted = [...cards].sort((a, b) => {
      if (controls.sort.value === 'name') return a.dataset.search.localeCompare(b.dataset.search);
      const direction = controls.sort.value === 'high' ? -1 : 1;
      return (Number(a.dataset.price) - Number(b.dataset.price)) * direction;
    });
    sorted.forEach(card => results.appendChild(card));
    count.textContent = `Showing ${visible} of ${cards.length} trade show${cards.length === 1 ? '' : 's'}`;
    empty.hidden = visible !== 0;
    reset.hidden = visible === cards.length && !query && controls.sort.value === 'low';
  }

  Object.values(controls).forEach(control => control.addEventListener('input', update));
  reset.addEventListener('click', () => {
    controls.search.value = '';
    controls.band.value = '';
    controls.region.value = '';
    controls.sector.value = '';
    controls.offer.value = '';
    controls.sort.value = 'low';
    update();
    controls.search.focus();
  });
})();
